var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-carousel', {
    attrs: {
      "indicator-position": "outside",
      "trigger": "click",
      "interval": 5000,
      "arrow": "never",
      "height": "530px"
    }
  }, _vm._l(_vm.array, function (item) {
    return _c('el-carousel-item', {
      key: item.index
    }, [_c('div', {
      staticClass: "roration"
    }, [_c('img', {
      attrs: {
        "src": _vm.isDark ? item.url[1] : item.url[0],
        "alt": ""
      }
    }), _c('div', [_c('span', {
      staticClass: "modeLabel"
    }, [_vm._v(_vm._s(_vm.$t(`partyInfo.${item.label}`)))]), _c('span', {
      staticClass: "modeDetail"
    }, [_vm._v(_vm._s(_vm.$t(`partyInfo.${item.detail}`)))])])])]);
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };